import { render, staticRenderFns } from "./trainingFooter.vue?vue&type=template&id=3477c7c6&scoped=true&"
import script from "./trainingFooter.vue?vue&type=script&lang=js&"
export * from "./trainingFooter.vue?vue&type=script&lang=js&"
import style0 from "./trainingFooter.vue?vue&type=style&index=0&id=3477c7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477c7c6",
  null
  
)

export default component.exports